import { render, staticRenderFns } from "./ShowRmPricePopUp.vue?vue&type=template&id=70fa0837&scoped=true&"
import script from "./ShowRmPricePopUp.vue?vue&type=script&lang=js&"
export * from "./ShowRmPricePopUp.vue?vue&type=script&lang=js&"
import style0 from "./ShowRmPricePopUp.vue?vue&type=style&index=0&id=70fa0837&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fa0837",
  null
  
)

export default component.exports